<template>
  <rh-etapa-card
    titulo="Informações Pessoais"
    subtitulo="Dados básicos, estado civil, sexo, cor/raça, data de nascimento e líder imediato"
    icone="mdi-account-outline"
  >
    <ValidationObserver ref="obs" tag="div">
      <v-row>
        <v-col cols="12" class="d-flex flex-column flex-sm-row align-sm-center py-4">
          <v-avatar size="110" class="rh-avatar mr-sm-6 mb-4 mb-sm-0 align-self-center">
            <v-img v-if="fotoUrl" :src="fotoUrl" />
            <span v-else class="text-h3 font-weight-bold primary--text">
              {{ ((form.pessoal && form.pessoal.name) || "...").substr(0, 1).toUpperCase() }}
            </span>
          </v-avatar>

          <div v-if="podeEditarFoto" class="text-center text-sm-left">
            <v-btn
              color="primary"
              outlined
              small
              class="font-weight-bold rounded-lg"
              :loading="uploadingFoto"
              @click="$refs.inputFoto.click()"
            >
              <v-icon left>mdi-camera</v-icon>
              Alterar Foto
            </v-btn>
            <input
              ref="inputFoto"
              type="file"
              accept="image/*"
              style="display: none"
              @change="aoSelecionarFoto"
            />
            <div class="text-caption grey--text mt-1">
              Apenas arquivos de imagem (JPEG, PNG). Máx: 2MB.
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="4" class="pt-0 pb-0">
          <ValidationProvider name="Nome Completo" rules="required" v-slot="{ errors }">
            <e-label>Nome Completo</e-label>
            <v-text-field
              :error-messages="errors"
              v-model="form.pessoal.name"
              dense
              solo
              disabled
            />
          </ValidationProvider>
        </v-col>

        <v-col cols="12" md="4" class="pt-0 pb-0">
          <e-label>Estado Civil</e-label>
          <v-autocomplete
            :items="$constants.estadosCivisList"
            :return-object="false"
            item-value="id"
            item-text="descricao"
            v-model="form.pessoal.estado_civil_id"
            label="Selecione uma opção"
            dense
            solo
          />
        </v-col>

        <v-col cols="12" md="4" class="pt-0 pb-0">
          <e-label>Sexo</e-label>
          <v-autocomplete
            :items="$constants.sexoList"
            :return-object="false"
            item-value="id"
            item-text="descricao"
            v-model="form.pessoal.sexo_id"
            label="Selecione uma opção"
            dense
            solo
          />
        </v-col>

        <v-col cols="12" md="4" class="pt-0 pb-0">
          <e-label>Cor/Raça</e-label>
          <v-autocomplete
            :items="$constants.corOuRacaList"
            :return-object="false"
            v-model="form.pessoal.cor_ou_raca"
            label="Selecione uma opção"
            dense
            solo
          />
        </v-col>

        <v-col cols="12" md="4" class="pt-0 pb-0">
          <e-label>Data de nascimento</e-label>
          <e-date-customize dense solo v-model="form.pessoal.data_nascimento" />
        </v-col>

        <v-col cols="12" md="4" class="pt-0 pb-0">
          <e-label>Líder Imediato</e-label>
          <v-autocomplete
            :items="lideresList"
            :return-object="false"
            item-value="id"
            item-text="name"
            v-model="form.pessoal.lider_id"
            label="Selecione o Líder"
            dense
            solo
            clearable
          />
        </v-col>
      </v-row>
    </ValidationObserver>

    <rh-documentos-secao
      categoria="pessoais"
      titulo="Documentos pessoais"
      subtitulo="Ex.: certidão de nascimento ou casamento, título de eleitor, reservista."
      :itens="documentos"
      v-on="$listeners"
    />
  </rh-etapa-card>
</template>

<script>
import RhEtapaCard from "../components/RhEtapaCard.vue";
import RhDocumentosSecao from "../components/RhDocumentosSecao.vue";

export default {
  name: "EtapaInformacoesPessoais",
  components: { RhEtapaCard, RhDocumentosSecao },
  props: {
    form: { type: Object, required: true },
    lideresList: { type: Array, default: () => [] },
    podeEditarFoto: { type: Boolean, default: false },
    uploadingFoto: { type: Boolean, default: false },
    documentos: { type: Array, default: () => [] },
  },
  computed: {
    fotoUrl() {
      if (this.form.pessoal && this.form.pessoal.foto) {
        const apiHost = (process.env.VUE_APP_API_HOST || "").replace(/\/$/, "");
        const token = localStorage.getItem("access_token") || "";
        const tokenParam = token ? `?token=${token}` : "";
        return `${apiHost}/recursos-humanos/foto/${this.form.pessoal.foto}${tokenParam}`;
      }
      return null;
    },
  },
  methods: {
    validar() {
      return this.$refs.obs.validate();
    },
    aoSelecionarFoto(event) {
      const file = event.target.files && event.target.files[0];
      if (file) {
        this.$emit("selecionar-foto", file);
      }
      this.$refs.inputFoto.value = "";
    },
  },
};
</script>

<style scoped>
.rh-avatar {
  background: var(--brand-soft);
  border: 3px solid var(--brand);
  box-shadow: 0 4px 12px var(--shadow);
}
</style>
